/**
 * Validation utilities for forms and inputs
 */
export function hasText(value) {
    if (!value || typeof value != 'string')
        return false;
    return value.trim().length > 0;
}
export function nonNull(value) {
    if (value == null)
        throw new Error('Unexpected null');
    return value;
}
/**
 * Validates the given input, possibly setting an error.
 * @param inputValue the input to validate
 * @param validator a validator that returns a string on error, undefined when ok
 * @param errorSetter an error setter that takes the error string
 * @param trim if true (default), the input will be trimmed before validation
 * @returns true if validation succeeded, false if not
 */
export const validateInput = (inputValue, validator, errorSetter, trim = true) => {
    const value = trim ? inputValue.trim() : inputValue;
    const v = validator(value);
    errorSetter(v);
    return !v;
};
/**
 * Helper function to create onChange for Inputs with input validation.
 * @param setter a setter that takes the input string
 * @param validator a validation function that return a falsish value if correct, and T as result if not
 * @param errorSetter a function that takes T to show an error if validation failed
 * @param validationNeedChecker if set, this will check whether validation is needed before validating
 * @param trimmer whether to trim the input string
 * @returns a handler function
 */
export const createOnChangeHandler = (setter, validator, errorSetter, validationNeedChecker, trimmer) => (value) => {
    const value1 = trimmer ? trimmer(value) : value;
    setter(value1);
    if (!validationNeedChecker || validationNeedChecker())
        errorSetter(validator(value1));
};
export function validateEmail(email) {
    if (email.length == 0)
        return 'missing';
    return email.length < 100 && /^[^@]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9.-]+$/.test(email) ? undefined : 'bad';
}
